/*
         * @ngdoc function
         * @name ePay.Model:Session_AppleSubmissionModel
         * @description
         * Model
         */
import { Session_ApplePayModel } from './Session_ApplePayModel';
import { Session_AppleDetailsModel } from './Session_AppleDetailsModel';
import { Session_AppleAddressModel } from './Session_AppleAddressModel';

export class Session_AppleSubmissionModel {
	applePayRaw: Session_ApplePayModel;
	details: Session_AppleDetailsModel;
  methodName: string | null | undefined;
  payerEmail: string | null | undefined;
  payerName: string | null | undefined;
  payerPhone: string | null | undefined;
	shippingAddress: Session_AppleAddressModel;

	constructor(
		applePayRaw?: Session_ApplePayModel, 
		details?: Session_AppleDetailsModel, 
		methodName?: string, 
		payerEmail?: string, 
		payerName?: string, 
		payerPhone?: string, 
		shippingAddress?: Session_AppleAddressModel
	) {
		this.applePayRaw = applePayRaw || new Session_ApplePayModel();
		this.details = details || new Session_AppleDetailsModel();
		this.methodName = methodName || null;
		this.payerEmail = payerEmail || null;
		this.payerName = payerName || null;
		this.payerPhone = payerPhone || null;
		this.shippingAddress = shippingAddress || new Session_AppleAddressModel();
	}
}
